// src/components/backend/companies/sections/SectionKontakt.jsx
import React from "react";
import { Box, TextField } from "@mui/material";

export default function SectionKontakt({ form, setForm }) {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr 1fr",
                },
                gap: 2,
            }}
        >
            <TextField
                label="Adressinfo / Zusatz"
                value={form.address_info || ""}
                onChange={(e) => setForm((f) => ({ ...f, address_info: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Straße / Nr."
                value={form.street || ""}
                onChange={(e) => setForm((f) => ({ ...f, street: e.target.value }))}
                fullWidth
            />

            <TextField
                label="PLZ"
                value={form.zip || ""}
                onChange={(e) => setForm((f) => ({ ...f, zip: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Ort"
                value={form.city || ""}
                onChange={(e) => setForm((f) => ({ ...f, city: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Kanton / Bundesland"
                value={form.canton_state || ""}
                onChange={(e) => setForm((f) => ({ ...f, canton_state: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Land"
                value={form.country || ""}
                onChange={(e) => setForm((f) => ({ ...f, country: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Telefon 1"
                value={form.phone1 || ""}
                onChange={(e) => setForm((f) => ({ ...f, phone1: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Telefon 2"
                value={form.phone2 || ""}
                onChange={(e) => setForm((f) => ({ ...f, phone2: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Mobil / SMS"
                value={form.mobile_sms || ""}
                onChange={(e) => setForm((f) => ({ ...f, mobile_sms: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Telefax"
                value={form.telefax || ""}
                onChange={(e) => setForm((f) => ({ ...f, telefax: e.target.value }))}
                fullWidth
            />

            <TextField
                label="E-Mail-Adresse"
                value={form.email || ""}
                onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Reservations-E-Mail"
                value={form.reservations_email || ""}
                onChange={(e) => setForm((f) => ({ ...f, reservations_email: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Facebook"
                value={form.facebook || ""}
                onChange={(e) => setForm((f) => ({ ...f, facebook: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Instagram"
                value={form.instagram || ""}
                onChange={(e) => setForm((f) => ({ ...f, instagram: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Twitter"
                value={form.twitter || ""}
                onChange={(e) => setForm((f) => ({ ...f, twitter: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Homepage"
                value={form.homepage || ""}
                onChange={(e) => setForm((f) => ({ ...f, homepage: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Breitengrad"
                value={form.latitude ?? ""}
                onChange={(e) => setForm((f) => ({ ...f, latitude: e.target.value }))}
                fullWidth
            />

            <TextField
                label="Längengrad"
                value={form.longitude ?? ""}
                onChange={(e) => setForm((f) => ({ ...f, longitude: e.target.value }))}
                fullWidth
            />
        </Box>
    );
}